import { releaseFeatures } from "@/config/releaseFeatures";
import { useEffect, useState } from "react";
import useTranslation from "next-translate/useTranslation";
import { useUser } from "@/redux/user";
import { claimPuzzleStreak } from "./claimPuzzleStreak";

export default function PuzzleStreakSave({
  source,
  puzzleId,
  moves,
  completed,
}: {
  source: "daily" | "theme";
  puzzleId: string | number;
  moves: string[];
  completed: boolean;
}) {
  const { t } = useTranslation("common");
  const { id, memberLoggedIn } = useUser();
  const [status, setStatus] = useState<"idle" | "saving" | "saved" | "error">(
    "idle",
  );
  const [retry, setRetry] = useState(0);
  const solution = moves.join(" ");
  useEffect(() => {
    if (!releaseFeatures.streaks || !completed || !puzzleId) {
      setStatus("idle");
      return;
    }
    let alive = true;
    setStatus("saving");
    void claimPuzzleStreak(source, puzzleId, solution.split(" "))
      .then(() => {
        if (alive) setStatus("saved");
      })
      .catch(() => {
        if (alive) setStatus("error");
      });
    return () => {
      alive = false;
    };
  }, [completed, memberLoggedIn, id, source, puzzleId, solution, retry]);
  if (status === "idle") return null;
  return (
    <div className="mt-3 text-xs leading-5 text-slate-500" aria-live="polite">
      {t(
        status === "saved"
          ? "chessStreak.saved"
          : status === "error"
            ? "chessStreak.saveError"
            : "chessStreak.saving",
      )}
      {status === "error" && (
        <button
          type="button"
          onClick={() => setRetry((n) => n + 1)}
          className="ml-2 min-h-[44px] text-altblue-600 underline"
        >
          {t("Try again")}
        </button>
      )}
    </div>
  );
}
